import { render, staticRenderFns } from "./OrcamentoAvisos.vue?vue&type=template&id=47f5040e&scoped=true"
import script from "./OrcamentoAvisos.vue?vue&type=script&lang=js"
export * from "./OrcamentoAvisos.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoAvisos.vue?vue&type=style&index=0&id=47f5040e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f5040e",
  null
  
)

export default component.exports